import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CoreValueSection from "./components/CoreValueSection";
import ServicesSection from "./components/ServicesSection";
import OutcomesSection from "./components/OutcomesSection";
import ProcessSection from "./components/ProcessSection";
import HomeCTASection from "./components/HomeCTASection";
import { useTheme } from "@/context/ThemeContext";

export default function Home() {
  const { theme } = useTheme();
  return (
    <div className={`min-h-screen transition-colors duration-300 ${theme === "dark" ? "bg-[#0a0a0a]" : "bg-white"}`}>
      <Navbar />
      <main>
        <HeroSection />
        <CoreValueSection />
        <ServicesSection />
        <OutcomesSection />
        <ProcessSection />
        <HomeCTASection />
      </main>
      <Footer />
    </div>
  );
}
